export default "__VITE_ASSET__04egBrBr__"